module.exports = __webpack_public_path__ + "img/bg-form-lower-tablet.112af0d0.png";